<div class="mobile-container">
  <span class="box-border-payment">
    <ng-container>
      <div class="row">
        <div class="col-2">
          <span aria-hidden="true" role="img">
                <img alt="current plan icon" aria-hidden="true" class="current-plan-icon"
                  src="{{currentPlanIcon}}" />
          </span>
        </div>

        <div class="col-9">
          <div class="payment-summary-wrapper">
            <div class="sub-details-text mb-2" data-testid="plan-summary-title" >{{ subSummaryTitle }}</div>
            <div>
                <div *ngIf="snapFlagEnabled && hasPendingSubscription; else defaultCurrentPlan">
                        <div class="sub-plan-text mt-2" data-testid="free-trial-end-date" id="freetrial-enddate" [innerHTML]="freeTrialEndDateText"></div>
                        <div class="sub-plan-text mt-2" data-testid="subscription-type" id="subscription-type" [innerHTML]="subscriptionTypeDetails"></div>
                        <div class="sub-enddate-text renew mt-2" data-testid="subscription-end-or-renewal-date" id="subscription-enddate" *ngIf="showSubscriptionEndDate" [innerHTML]="subscriptionEndDateText"></div>
                        <div class="sub-plan-text mt-2" data-testid="renewal-cost-text" id="renewal-cost-text" [innerHTML]="renewalCostText"></div>
                </div>
                <ng-template #defaultCurrentPlan>
                        <div class="sub-plan-text mt-2" data-testid="free-trial-end-date" id="freetrial-enddate" [innerHTML]="freeTrialEndDateText"></div>
                        <div class="sub-plan-text mt-2" data-testid="subscription-type" id="subscription-type" [innerHTML]="subscriptionTypeDetails"></div>
                        <div class="sub-plan-text mt-2" data-testid="renewal-cost-text" id="renewal-cost-text" [innerHTML]="renewalCostText"></div>
                        <div class="sub-enddate-text renew mt-2" data-testid="subscription-end-or-renewal-date" id="subscription-enddate" *ngIf="showSubscriptionEndDate" [innerHTML]="subscriptionEndDateText"></div>
                </ng-template>
                <div class="change-plan-cancel-plan-container">
                        <div (click)="goToChangePlan()" *ngIf="showChangePlanLink" (keydown.enter)="goToChangePlan()"
                                class="links__action__default change-plan mt-2 plan-item" id="change-plan" role="link"
                                tabindex="0">
                                {{programDisplayData?.manage?.CHANGE_PLAN}}
                        </div>
                        <div class="vertical-separator" *ngIf="showChangePlanLink"></div> <!-- Vertical separator -->
                        <div (click)="goToCancelPlan()" (keydown.enter)="goToCancelPlan()" *ngIf="showCancelFpPlanLink"
                                class="links__action__default change-plan mt-2 plan-item" role="link" tabindex="0">
                                {{programDisplayData?.manage?.Cancel_FreshPass}}
                        </div>
                </div>
              <div *ngIf="showCanNotChangePlanText" class="sub-no-changeplan-text mt-3" id="no-change-plan" tabindex="0">
                {{programDisplayData?.manage?.YOUR_PLAN_CAN_NOT_BE_CHANGED_AGAIN_UNTIL_THE_CURRENT_UPDATE_IS_COMPLETE}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </span>
</div>
